// Camera: board point at the viewport's top-left and zoom (screen px per board px).
export interface Cam { x: number; y: number; z: number }

export const MIN_ZOOM = 0.05;
export const MAX_ZOOM = 4;

export const toBoard = (c: Cam, sx: number, sy: number) => ({ x: c.x + sx / c.z, y: c.y + sy / c.z });
export const toScreen = (c: Cam, bx: number, by: number) => ({ x: (bx - c.x) * c.z, y: (by - c.y) * c.z });

/** Zooms by `factor` keeping the board point under (sx, sy) fixed. */
export function zoomAt(c: Cam, sx: number, sy: number, factor: number): Cam {
  const z = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, c.z * factor));
  const b = toBoard(c, sx, sy);
  return { x: b.x - sx / z, y: b.y - sy / z, z };
}

/** Camera that shows `rect` (board px) in a viewport of vw×vh with a margin. */
export function fit(rect: [number, number, number, number], vw: number, vh: number, margin = 48): Cam {
  const [x, y, w, h] = rect;
  const z = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, Math.min((vw - 2 * margin) / Math.max(w, 1), (vh - 2 * margin) / Math.max(h, 1))));
  return { x: x + w / 2 - vw / (2 * z), y: y + h / 2 - vh / (2 * z), z };
}
